// extracted by mini-css-extract-plugin
export default {"body":"Demarche_body__QJRfK","majsite":"Demarche_majsite__2OI9p"};